<template>
  <router-view />
</template>

<script setup>
import '@vuepic/vue-datepicker/dist/main.css'

</script>
  